module.exports = {"errorRequired":"This field is required. - FR","errorInvalid":"The format is invalid. - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/locales/fr.json
// module id = 1348
// module chunks = 0